import {
  calculate as calculateProductOptions,
  CalculateProductOptionsPriceAdditionParams,
} from '@calculations/price/utilities/product-options';
import { CalculationConfig } from '@calculations/types/calculation-config';
import type { VisualMarketPrice } from '@snap-types/models/visual/market-price';
import { Decimal } from '@snap-types/types/decimal';

import {
  calculate as calculateFixedMarket,
  FixedMarketCalculateParams,
} from '../fixed-market/calculate';

export type RAFPartOptionsCalculateParams = FixedMarketCalculateParams &
  CalculateProductOptionsPriceAdditionParams;

export type RAFPartOptionsCalculateResult = {
  quantity: Decimal;
  marketCode: string;
  unitPrice: Decimal;
  marketPrice: VisualMarketPrice;
  unitPriceAddition: Decimal;
  changesUnitPrice: boolean;
};

export function calculate(
  {
    quantity,
    marketCode,
    marketPrices,
    productOptions,
    craftProductOptions,
  }: RAFPartOptionsCalculateParams,
  config: CalculationConfig,
): RAFPartOptionsCalculateResult | null {
  const fixedMarketResult = calculateFixedMarket(
    {
      quantity,
      marketCode,
      marketPrices,
    },
    config,
  );

  if (!fixedMarketResult) {
    // @TODO(#2018): Return contextual error
    return null;
  }

  const productOptionsResult = calculateProductOptions(
    {
      quantity,
      productOptions,
      craftProductOptions,
    },
    config,
  );

  if (!productOptionsResult.isSuccess) {
    // @TODO(#2018): Return contextual error
    return null;
  }

  const unitPrice = fixedMarketResult.unitPrice
    .plus(productOptionsResult.unitPriceAddition)
    .toDecimalPlaces(config.decimalPlaces);

  return {
    quantity,
    marketCode,
    unitPrice,
    marketPrice: fixedMarketResult.marketPrice,
    unitPriceAddition: productOptionsResult.unitPriceAddition,
    changesUnitPrice: productOptionsResult.changesUnitPrice,
  };
}
